// The one definition of a compact form control, shared by every editor that
// collapses its rows.
//
// Signals and overrides are the same gesture on two pages: a scannable list of
// one-line rows, each opening into a form. They had drifted into two sizes,
// because the signals editor styled its selects inline and the override form
// inherited whatever `react-select` defaults to, so an open override rule was
// visibly taller and heavier than an open signal.
//
// It has to be a style object rather than CSS: `react-select` emits hashed class
// names, so a stylesheet cannot reach its control, which is what `controlStyles`
// on `GenericSelect` exists for.

/** Comfortable for one form, and a wall for a list of them. */
export const FORM_COMP_HEIGHT = '38px';

/** The same height a collapsed list's open row uses. */
export const COMPACT_COMP_HEIGHT = '32px';

/**
 * The tree page's hairline. `react-select` ships a heavier default border than
 * Bootstrap, which put two weights of outline next to each other in one row.
 */
const HAIRLINE = '#dbe3ea';

/**
 * Undefined when not compact, deliberately.
 *
 * Returning a default height instead would put a style on every control of the
 * two editors that do NOT opt in, which is a change to the unflagged Overrides
 * page and the aggregations wizard for no reason. A caller that wants a
 * non-compact height asks for one.
 */
export const compactSelectStyles = (compact?: boolean) =>
  compact
    ? {
        height: COMPACT_COMP_HEIGHT,
        minHeight: COMPACT_COMP_HEIGHT,
        borderColor: HAIRLINE,
      }
    : undefined;

/** Height for the plain inputs beside those selects, so a row lines up. */
export const compactControlHeight = (compact?: boolean) =>
  compact ? COMPACT_COMP_HEIGHT : undefined;
